module.exports = __webpack_public_path__ + "static/media/firma.2f5575c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/firma.png
// module id = 1580
// module chunks = 0